(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('asteriskString', function () {
        return function (str, isFull) {
            if (str) {
                str = str.toString();
                var asteriskStr = '';
                var visiblePos = [
                    0,
                    1,
                    2,
                    3
                ];
                _(str).each(function (charactor, position) {
                    if (isFull) {
                        asteriskStr += '*';
                    } else {
                        if (charactor === ' ' || _(visiblePos).findIndex(function (pos) {
                                return pos === position;
                            }) !== -1 || position === str.length - 1) {
                            asteriskStr += charactor;
                        } else {
                            asteriskStr += '*';
                        }
                    }
                });
                return asteriskStr;
            }
            return '';
        };
    });
}());